(ns ycweb.app.pos.admin.labels
  (:require
   [rum.core :as rum]
   [util.string :as str]
   #?@(:clj
       [[clojure.core.async :as a]]
       :cljs
       [[cljs.core.async :as a]])
   [ycweb.app.pos.pricetags.pricetags :as pricetags]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]
   [ycweb.components.forms :as forms]
   [ycweb.components.wrapper :as w]
   [ycweb.components.transitions :as t]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.app.pos.admin.labels.grouped]
   [ycweb.app.pos.admin.labels.type]
   [ycweb.app.pos.admin.labels.sticker]
   [ycweb.app.pos.admin.labels.location]))

(def printing-steps
  (forms/setup-steps
    [{:key :label-set-options :title "Select a label set to print"}]))

(defn store-permission? [app-atom blitz?]
  (and
    (not blitz?)
    (or
      (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
      (cmn/has-permission? app-atom "SiteAdmin:Store:Manager")
      (cmn/has-permission? app-atom "SiteAdmin:Store:Regional Manager"))))

(defn warehouse-permission? [app-atom blitz?]
  (and
    blitz?
    (or
      (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
      (cmn/has-permission? app-atom "SiteAdmin:Weber")
      (cmn/has-permission? app-atom "SiteAdmin:Weber:Reports"))))

(rum/defc labels-set-screen < rum/reactive [app-atom]
  (let  [blitz? (cmn/curact app-atom :blitz?)]
    (w/wrapper app-atom (str (if blitz? "Warehouse" "Store") " Admin") {:steps printing-steps :step :label-set-options}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         "What would you like to print?"]
        [:a.card.tile.u-angled-background.u-bg-asphalt.u-min-height-160
         {:on-click
          #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :location})}
         [:span.tile__content
          [:span.tile__icon-wrapper]
          [:span.tile__text "Location Labels"]]]
        [:a.card.or-card.tile.u-angled-background.u-bg-yellow.u-min-height-160
         {:on-click
          #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :sticker})}
         [:span.tile__content
          [:span.tile__icon-wrapper]
          [:span.tile__text "Stickers"]]]
        (when (store-permission? app-atom blitz?)
          [:a.card.or-card.tile.tile.u-angled-background.u-bg-blue.u-min-height-160
           {:on-click
            #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :collection})}
           [:span.tile__content
            [:span.tile__icon-wrapper]
            [:span.tile__text "Collection Labels"]]])
        (when (store-permission? app-atom blitz?)
          [:a.card.or-card.tile.u-angled-background.u-bg-mint-green.u-min-height-160
           {:on-click
            #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :store})}
           [:span.tile__content
            [:span.tile__icon-wrapper]
            [:span.tile__text "Store Labels"]]])
        (when (store-permission? app-atom blitz?)
          [:a.card.or-card.tile.u-angled-background.u-bg-plum.u-min-height-160
           {:on-click
            #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :bay})}
           [:span.tile__content
            [:span.tile__icon-wrapper]
            [:span.tile__text "Bay Labels"]]])
        (when (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
          [:a.card.or-card.tile.u-angled-background.u-bg-purple.u-min-height-160
           {:on-click
            #(grid/dispatch-action app-atom :store-admin/labels-set-option {:label-set :bay-products})}
           [:span.tile__content
            [:span.tile__icon-wrapper]
            [:span.tile__text "Bay Product Labels"]]])]]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :store-admin/printer-labels [app-atom]
  (labels-set-screen app-atom))

(defmethod grid/action :store-admin/labels-set-option [app-atom config]
  (let [process-atom (cmn/process-cursor app-atom)
        store-admin-atom (rum/cursor process-atom :store-admin)
        label-set (:label-set config)]
    (reset! store-admin-atom config)
    (cond
      (= label-set :bay-products)
      (t/transition-next app-atom :store-admin/label-type-select)

      (= label-set :location)
      (t/transition-next app-atom :store-admin/location-labels)

      (= label-set :sticker)
      (t/transition-next app-atom :store-admin/print-stickers)

      :else
      (t/transition-next app-atom :store-admin/printer-scan))))

